<template>
  <PageLayout>
    <template #headerTitle>Gestion des publicités</template>

    <VBusHelper :emitOnMounted="$constants.EVENTS.ADS.LIST_ALL.REFRESH" />

    <!-- HEADER WITH CREATE BUTTON -->
    <div class="flex justify-between items-center mb-6">
      <div class="text-gray-600">
        {{ $stores.ads?.state?.list_all?.list?.length || 0 }} publicité(s)
      </div>
      <button
        class="px-6 py-2.5 rounded-xl bg-primary-600 text-white font-medium hover:bg-primary-700 transition-all"
        @click="$bus.emit($constants.EVENTS.ADS.CREATE_OR_UPDATE.SHOW, null)"
      >
        + Nouvelle publicité
      </button>
    </div>

    <!-- ERROR STATE -->
    <AdsLoadingError
      v-if="$stores.ads?.state?.list_all?.error"
      @refresh="() => $bus.emit($constants.EVENTS.ADS.LIST_ALL.REFRESH)"
    >
      <template #errorDescription>
        {{ $stores.ads?.state?.list_all?.error }}
      </template>
    </AdsLoadingError>

    <!-- ADS GRID -->
    <div
      v-else-if="$stores.ads?.state?.list_all?.list?.length"
      class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6"
    >
      <div
        v-for="(ad, index) in $stores.ads?.state?.list_all?.list"
        :key="ad.id || index"
        class="bg-slate-100 rounded-2xl overflow-hidden group hover:shadow-lg transition-all"
      >
        <!-- IMAGE PREVIEW -->
        <div class="relative h-48 bg-gray-200">
          <ImgComponent
            :src="ad.pictureUrl"
            alt="Publicité"
            class="w-full h-full object-cover"
          />
          <div class="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-all flex items-end justify-center pb-4">
            <button
              class="px-6 py-2 rounded-xl bg-white text-gray-900 font-medium hover:bg-gray-100 transition-all"
              @click="$bus.emit($constants.EVENTS.ADS.CREATE_OR_UPDATE.SHOW, ad)"
            >
              Modifier
            </button>
          </div>
        </div>

        <!-- AD INFO -->
        <div class="p-4 space-y-3">
          <!-- TITLE -->
          <div v-if="ad.title">
            <div class="text-xs text-gray-500">Titre</div>
            <div class="font-medium text-gray-900 truncate">{{ ad.title }}</div>
          </div>

          <!-- DESCRIPTION -->
          <div v-if="ad.description">
            <div class="text-xs text-gray-500">Description</div>
            <div class="text-sm text-gray-700 line-clamp-2">{{ ad.description }}</div>
          </div>

          <!-- URL LINK -->
          <div v-if="ad.targetUrl">
            <div class="text-xs text-gray-500">Lien de destination</div>
            <a
              :href="ad.targetUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 hover:underline truncate"
            >
              <svg class="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
              <span class="truncate">{{ ad.targetUrl }}</span>
            </a>
          </div>

          <!-- ACTIONS -->
          <div class="flex gap-2 pt-2 border-t border-gray-200">
            <button
              class="flex-1 px-4 py-2 rounded-lg bg-white text-gray-700 text-sm font-medium hover:bg-gray-50 transition-all"
              @click="$bus.emit($constants.EVENTS.ADS.CREATE_OR_UPDATE.SHOW, ad)"
            >
              Modifier
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- LOADING STATE -->
    <div
      v-else-if="$stores.ads?.state?.list_all?.loading"
      class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6"
    >
      <div
        v-for="i in 4"
        :key="i"
        class="bg-slate-100 rounded-2xl overflow-hidden shimmerContainer"
      >
        <div class="h-48 bg-gray-200 shimmerTarget"></div>
        <div class="p-4 space-y-3">
          <div class="h-4 bg-gray-200 rounded shimmerTarget"></div>
          <div class="h-3 bg-gray-200 rounded shimmerTarget"></div>
          <div class="h-3 bg-gray-200 rounded shimmerTarget w-2/3"></div>
        </div>
      </div>
    </div>

    <!-- EMPTY STATE -->
    <EmptyAds
      v-else
      @refresh="() => $bus.emit($constants.EVENTS.ADS.LIST_ALL.REFRESH)"
    />
  </PageLayout>
</template>
